import { useTranslation } from 'react-i18next';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { TextField } from 'src/shared/components/Form/TextField';
import { Step } from 'src/modules/SaldoView/components/CompanySelectorBar/components/Step';
import { DownloadField } from '../DownloadField';

export const AutomaticSteps = () => {
  const { t } = useTranslation('form');

  return (
    <Grid2>
      <Step step={1} title={t('field.mandate')} description={t('self funding.mandate description')}>
        <DownloadField />
      </Step>

      <Step step={2} title={t('field.iban of origin')}>
        <TextField
          disabled
          name="selfFundingDirectDebitIban"
          label={t('field.iban of origin')}
          InputProps={{
            style: { width: '100%' }
          }}
        />
      </Step>

      <Step step={3} title={t('field.automatic recharge day')}>
        <TextField
          disabled
          name="date"
          label={t('field.automatic recharge day')}
          InputProps={{
            style: { width: '100%' }
          }}
        />
      </Step>
    </Grid2>
  );
};
